import React from 'react';

import { RoutingFilterItem } from '../../types/RoutingFilterItem';
import { RoutingFilterTableRow } from './RoutingFilterTableRow';

export type RoutingFilterTableBodyProps = Readonly<{
  filters: ReadonlyArray<RoutingFilterItem>;
}>;

export function RoutingFilterTableBody(props: RoutingFilterTableBodyProps) {
  return (
    <tbody>
      {props.filters.map((filter: RoutingFilterItem) => (
        <RoutingFilterTableRow
          key={filter.id}
          filter={filter}
        />
      ))}
    </tbody>
  );
}
